<template>
  <button
    class="vs-btn-legacy"
    :class="{
      [$style.VideoInPlayerOverlayButton]: true,
      [$style[alignment]]: true,
      [$style.focus]: focus,
    }"
    type="button"
  >
    <slot />
  </button>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    alignment: {
      type: String as PropType<'left' | 'right' | 'center'>,
      default: 'left',
    },
    focus: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" module>
// Double selecting to increase specificity
.VideoInPlayerOverlayButton.VideoInPlayerOverlayButton {
  & {
    // General visual appearance
    background-color: rgba(white, 0.9);
    border-radius: 5em;
    box-shadow: 1px 1px 1px rgba(black, 0.1);

    // Internal spacing
    padding: 0.6em 1.4em;

    transition: transform 0.1s;
  }

  &.left {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding-left: 2em;
    transform: translateX(-1em);

  }
  &.right {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding-right: 2em;
    transform: translateX(1em);
  }
  &.center{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding-right: auto;
    padding-left: auto;
  }
  &:active,
  &:hover,
  &.focus {
    transform: translateX(0);
  }
}

</style>
